/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { useTheme } from '@mui/material/styles'
import { Box, Link, Typography, Button } from '@mui/material'

import { useSelector } from 'react-redux'
import { useLogoutMutation } from '../../redux/api/authApi'
import UserPayment from '../UserPayment'

import { PATH_LOGIN } from '../../routes/constant'
import UpdatePassword from '../updatePassword'
import { useEffect, useState } from 'react'
import UpdateEmail from '../updateEmail'
import LoginIcon from '@mui/icons-material/AccountCircleRounded'
import { useGetLastInvoiceLinkMutation } from '../../redux/api/userApi'

const UserInfo: React.FC = () => {
  const theme = useTheme()
  const [logout] = useLogoutMutation()
  const [getLastLinkInvoice, { isLoading, isSuccess, data }] = useGetLastInvoiceLinkMutation()
  const userState = useSelector((state: any) => state.userState)
  const { user } = userState
  const [isShowUpdatePasswordModal, setIsShowUpdateModal] = useState(false)
  const [isShowUpdateEmailModal, setIsShowUpdateEmailModal] = useState(false)
  const onLogoutHandler = async () => {
    await logout()
    window.location.href = PATH_LOGIN.LOGIN
  }

  useEffect(() => {
    if (isSuccess) {
      window.open(data.url, '_blank')
    }
  }, [isSuccess])

  return (
    <>
      <UpdateEmail isShowUpdateEmailModal={isShowUpdateEmailModal} setIsShowUpdateEmailModal={setIsShowUpdateEmailModal} />
      <UpdatePassword setIsShowUpdateModal={setIsShowUpdateModal} isShowUpdatePasswordModal={isShowUpdatePasswordModal} />
      <Box>
        <Box sx={{ display: 'flex' }}>
          <LoginIcon sx={{ color: 'rgba(195, 202, 217, 1)', height: 71, width: 71, marginRight: '18px' }}/>
          <Box sx={{ width: 'calc(100% - 71px)' }}>
            <Typography sx={{ color: theme.palette.grey[40] }} variant='h4'>
              {`${user.firstName} ${user.secondName}`}
            </Typography>
            <Link
              href={`mailto:${user.email}`}
              sx={{ color: theme.palette.grey[70], fontSize: 14, fontWeight: 400, mr: 0 }}
            >
              {user.email}
            </Link>
            <Box sx={{ alignItems: 'center', display: 'flex', gap: '20px', marginTop: '10px' }}>
              <Button
                  onClick={() => { setIsShowUpdateEmailModal(prev => !prev) }}
                sx={{ color: theme.palette.grey[70], fontSize: 12, fontWeight: 500, mr: 0, padding: 0 }}
              >
                Change Email
              </Button>
              <Button
                  onClick={() => { setIsShowUpdateModal(prev => !prev) }}
                sx={{ color: theme.palette.grey[70], fontSize: 12, fontWeight: 500, mr: 0, padding: 0 }}
              >
                Update Password
              </Button>
              <Link
                onClick={onLogoutHandler}
                sx={{ color: theme.palette.grey[70], fontSize: 12, fontWeight: 500, mr: 0 }}
              >
                Log Out
              </Link>
            </Box>
          </Box>
        </Box>
        <UserPayment/>
        <Button onClick={async () => await getLastLinkInvoice({})} disabled={isLoading} sx={
          {
            display: 'flex',
            width: '100%',
            color: '#919EB6',
            border: '1px solid #E8E8E8',
            borderRadius: '5px',
            mt: '10px',
            fontSize: '12px',
            fontWeight: 400,
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.1)'
          }
        }>View Invoice</Button>
      </Box>
    </>
  )
}

export default UserInfo
